import React, { FC } from 'react';

import { IImgUmbracoItem } from './models';
import './ImgUmbracoItem.scss';
import UmbracoImage from '../../Image/UmbracoImage';
import ImgItem from '../ImgItem';

const ImgUmbracoItem: FC<IImgUmbracoItem> = ({
  productImage,
  customImageToggle,
  imageCenter,
  imageCenterAlt,
}) => {
  const ImageItem =
    imageCenter && imageCenterAlt ? <ImgItem image={imageCenter} alt={imageCenterAlt} /> : null;
  const UmbracoImageItem = (
    <div className="dt-media-info-box__item-umbraco">
      <UmbracoImage image={productImage} alt="some text" />
    </div>
  );

  return Number(customImageToggle) ? UmbracoImageItem : ImageItem;
};

export default ImgUmbracoItem;
